export const blockIconsImageAddAPhoto = (
	<span className='material-symbols-outlined'>add_a_photo</span>
);
